module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/involvements/activities/activities.component.css
// module id = ./src/app/main/content/involvements/activities/activities.component.css
// module chunks = main